import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import SelectWrapper from '@/components/Base/Select/SelectWrapper';

import { Option, OptionInput, OptionLabel } from './Select.styles';

function Select({
  options = [],
  value: defaultValue = null,
  name = '',
  placeholder = '',
  onChange = () => {},
  ...rest
}) {
  const [value, setValue] = useState(defaultValue);
  const didMountCurrent = useRef(false);

  const getSelectedOption = () =>
    options?.find((option) => value?.toString() === option.value?.toString());

  const getSelectedOptionLabel = () => {
    const selectedOption = getSelectedOption();

    if (selectedOption) {
      return selectedOption?.selectedLabel || selectedOption?.label;
    }

    return null;
  };

  const selectedOptionLabel = getSelectedOptionLabel();

  const clearSelectedValues = () => {
    setValue('');
    onChange({ key: name, value: '' });
  };

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange({ key: name, value: event.target.value });
  };

  useEffect(() => {
    if (didMountCurrent.current) {
      setValue(defaultValue);
    } else {
      didMountCurrent.current = true;
    }
  }, [defaultValue]);

  return (
    <SelectWrapper
      renderValue={selectedOptionLabel}
      name={name}
      clearSelectedValues={clearSelectedValues}
      placeholder={placeholder}
      valuesLength={value ? 1 : 0}
      optionsLength={options?.length}
      {...rest}
    >
      {({ search }) =>
        options.map((option, index) => {
          let isMatch = search;

          if (isMatch) {
            isMatch = option?.label
              .toLowerCase()
              .includes(search.toLowerCase().trim());

            if (!isMatch) return null;
          }

          return (
            <Option htmlFor={`${name}-option-${index}`} key={option?.value}>
              <OptionInput
                id={`${name}-option-${index}`}
                type="checkbox"
                name={name}
                value={option?.value}
                checked={value?.toString() === option?.value?.toString()}
                onChange={handleChange}
              />

              <OptionLabel>{option?.label || null}</OptionLabel>
            </Option>
          );
        })
      }
    </SelectWrapper>
  );
}

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.number,
      ]),
      label: PropTypes.node,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
};

export default memo(Select);
